import {
  ChangeEvent,
  FunctionComponent,
  SyntheticEvent,
  useRef,
  useState,
} from "react";
import { Icon } from "../../../Icon";

import AuthButtons from "../../../AuthButtons";
import "./../styles.scss";
import UserDropDown from "../../../UserDropDown";
import useOnClickOutside from "../../../../utils/hooks/useOnClickOutside";
import CartSection from "../CartSection";

type Props = {
  handleSearch: (e: SyntheticEvent) => void;
  isAuth: boolean;
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  searchValue: string;
};

const AuthAndSearch: FunctionComponent<Props> = ({
  handleSearch,
  isAuth,
  handleChange,
  searchValue,
}) => {
  const [dropDownOpen, setDropDownOpen] = useState(false);

  const dropDownRef = useRef<HTMLDivElement>(null);
  useOnClickOutside(dropDownRef, () => setDropDownOpen(false));

  return (
    <div className="nav_search-auth">
      <form className="nav_search_bar" onSubmit={handleSearch}>
        <button>
          <Icon iconName="search_icon" className="search-icon__desktop" />
        </button>
        <input
          type="text"
          placeholder="Buscar..."
          name="product"
          id="product"
          onChange={handleChange}
          value={searchValue}
        />
      </form>
      {isAuth && (
        <div className="nav__is-auth">
          <div className="nav_icons">
            <div
              className="user__container"
              ref={dropDownRef}
              onClick={() => {
                setDropDownOpen(!dropDownOpen);
              }}
            >
              <Icon iconName="user" className="nav_user" />
              {dropDownOpen && <UserDropDown setIsOpen={setDropDownOpen} />}
            </div>
            <CartSection />
          </div>
        </div>
      )}
      {!isAuth && <AuthButtons />}
    </div>
  );
};

export default AuthAndSearch;
